import { Box, type BoxProps } from '@companydotcom/potion';
import { motion } from 'framer-motion';

export const MotionBox = motion<BoxProps>(Box);
